<template>
  <tbody class="search__result search__result--empty" v-if="filteredResults === undefined || filteredResults.length === 0">
    <tr>
      <td colspan="6">
        <p class="search__result__introtext" v-if="filteredResults === undefined || filteredResults.length === 0">
          Achten Sie bitte darauf, dass unsere Label-Datenbank wöchentlichen
          Aktualisierungen unterliegt, da sich die Anzahl der durch die GVL
          vertretenen Label erhöhen kann. Zudem können sich die Hersteller
          (Inhaber) der Label und die Rechterückrufe ändern.
        </p>
        <p class="search__result__introtext" v-if="filteredResults === undefined || filteredResults.length === 0">
          In den GEMA/GVL-Sendemeldungen sind Labelcode und Label oder alternativ
          Labelcode und Kurzname anzugeben. Die Kennzeichnung „PLM“ (Musik einer
          Production Library/Archivmusik) ist eine Kategorisierung des Repertoires
          eines Labels. Über die Auswirkungen dieser Kennzeichnung für die
          GEMA/GVL-Sendemeldungen informieren Sie sich bitte bei der Sendeanstalt,
          für die Sie die Meldung erstellen.
        </p>
        <p class="info__no_labels">Eine Liste der von der GVL über Schwestergesellschaften vertretenen
          Tonträgerhersteller ohne Labelregistrierung finden Sie <a :href="downloadProducerWithoutLabelsPdfUrl" target="_blank" download>hier</a>. Bitte beachten Sie, dass die GVL die Rechte
          dieser Hersteller gleichermaßen vertritt wie die Rechte der Hersteller, die bei der GVL ein Label angemeldet
          haben. Allerdings kann der Umfang der von der GVL vertretenen Rechte für einige Nutzungsarten eingeschränkt
          sein. Bei Fragen zur Verwendung des Repertoires dieser Hersteller wenden Sie sich bitte an die GVL.
        </p>
      </td>
    </tr>
  </tbody>
</template>

<script>
const URL_PROD_WITHOUT_LABELS_PDF = '/Liste-Tontraegerhersteller-ohne-Labels.pdf'

export default {
  name: 'SearchResultEmpty',
  components: {
  },
  props: {
    filteredResults: Array
  },
  data () {
    return {
      downloadProducerWithoutLabelsPdfUrl: URL_PROD_WITHOUT_LABELS_PDF
    }
  }
}
</script>
